import { Text } from "@redotech/arbiter/text";
import { DATE_FORMAT } from "@redotech/redo-web/time";
import { memo } from "react";
import type { OrderTrackingBillingValue } from "./order-tracking-billing";
import {
  formatNestedBillingFieldValue,
  formatNestedBillingFieldValueFromForm,
  invoiceBillingValuesEqual,
  type OrderTrackingBillingPeriodComparePath,
  type OrderTrackingBillingPeriodSnapshot,
} from "./order-tracking-billing-period-utils";

export const OrderTrackingBillingPeriodChangeHint = memo(
  function OrderTrackingBillingPeriodChangeHint({
    fieldPath,
    invoiceBilling,
    nextPeriodStart,
    snapshot,
  }: {
    fieldPath: OrderTrackingBillingPeriodComparePath;
    invoiceBilling: OrderTrackingBillingValue["invoiceBilling"];
    nextPeriodStart: Date;
    snapshot: OrderTrackingBillingPeriodSnapshot;
  }) {
    if (invoiceBillingValuesEqual(invoiceBilling, snapshot, fieldPath)) {
      return null;
    }

    const oldValue = formatNestedBillingFieldValue(fieldPath, snapshot);
    const newValue = formatNestedBillingFieldValueFromForm(
      fieldPath,
      invoiceBilling,
    );

    return (
      <Text fontSize="xs" textColor="warning">
        For the current period, the old value of {oldValue} will be used. The
        new value of {newValue} will apply starting with the period that begins
        on {DATE_FORMAT.format(nextPeriodStart)}.
      </Text>
    );
  },
);
